import React, { useState } from 'react';
import { RemoveRedEye } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Button,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Tooltip,
    Typography,
} from '@mui/material';
import { colors } from '../../assets/utils/constants';
import CustomDialog from '../Dialogs/CustomDialog';
import ORGApplicantDetails from '../../pages/jobs/components/ORGApplicantDetails';

const JobApplicantWidget = ({ applicant }) => {
    // ############### Comp State ##################
    const [openDialog, setOpenDialogy] = useState(false);

    // ############### FUNC ##################
    // -> Dialogy closer
    const handleDialogOpen = (actionType) => {
        setOpenDialogy(true);
    };

    // -> Dialogy closer
    const handleDialogClose = () => {
        setOpenDialogy(false);
    };

    return (
        <>
            {/* ############# Dialog ################ */}
            <CustomDialog
                head={'Job applicant details'}
                openDialog={openDialog}
                customWidth={'md'}
                handleDialogClose={handleDialogClose}
            >
                <ORGApplicantDetails
                    applicant={applicant}
                    handleDialogClose={handleDialogClose}
                />
            </CustomDialog>

            <ListItem
                alignItems="flex-start"
                secondaryAction={
                    <Tooltip title="Applicant details" arrow>
                        <Button
                            sx={{
                                bgcolor: colors.bgColor3,
                            }}
                            onClick={() => {
                                handleDialogOpen();
                            }}
                        >
                            <RemoveRedEye color="info" sx={{ fontSize: 20 }} />
                        </Button>
                    </Tooltip>
                }
                sx={{
                    'transition': '.3s all ease-in-out',
                    'background': `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                    'position': 'relative',
                    'mb': 2,
                    'borderRadius': 2,
                    'transition': '.3s all ease-in-out',
                    'border': `1px solid ${colors.bgColor3}`,
                    ':hover': {
                        transition: '.3s all ease-in-out',
                        border: `1px solid ${colors.bgColor5}`,
                    },
                }}
            >
                <ListItemAvatar>
                    <Avatar
                        alt="Remy Sharp"
                        src={applicant.org_logo}
                        sx={{
                            height: 70,
                            width: 70,
                            mt: -0.5,
                            mr: 1.5,
                            border: `3px solid ${colors.bgColor5}`,
                            background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor5})`,
                            img: {
                                objectFit: 'contain',
                            },
                        }}
                    />
                </ListItemAvatar>
                <ListItemText
                    disableTypography
                    primary={
                        <Typography
                            sx={{
                                fontSize: 15,
                                fontWeight: 'bold',
                            }}
                        >
                            {`${applicant.organization_name}`}
                        </Typography>
                    }
                    secondary={
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                sx={{
                                    fontSize: 13,
                                }}
                                component="span"
                            >
                                {applicant.organization_category.name} - Org
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: colors.info,
                                    fontWeight: 'bold',
                                }}
                                component="span"
                            >
                                {applicant?.location}
                            </Typography>
                        </Box>
                    }
                />
            </ListItem>
        </>
    );
};

export default JobApplicantWidget;
